import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxuryurbaniaonrentinlonavala() {



    const cardData =
    {
        keyword: 'Luxury Urbania On Rent in Lonavala',
        heading: 'Urbania on rent in pune: Luxury Urbania On Rent in Lonavala',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Luxury Urbania On Rent in Lonavala services for families, corporate groups, tourists, and event travelers planning trips to the scenic hill station of Lonavala. Our well‑maintained luxury Force Urbania fleet provides spacious seating, plush interiors, powerful air‑conditioning, and smooth performance, making it ideal for weekend getaways, corporate outings, airport transfers, weddings, sightseeing tours, and outstation journeys from Pune to Lonavala. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a refined, punctual, and stress‑free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for luxury Urbania hire in Lonavala.',

        top: 'Top Places to Visit in Lonavala with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Tiger’s Leap",
    "description": "Tiger’s Leap is a spectacular cliff-top with panoramic views of the lush Western Ghats and the valley below. Famous for its dramatic drop of over 650 meters, it offers mesmerizing sunrise and sunset vistas. Visitors enjoy trekking, photography, and the cool mountain breeze. It is one of Lonavala’s most iconic viewpoints, attracting nature lovers and adventure enthusiasts alike."
  },
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam, located on the Indrayani River, is a popular monsoon destination in Lonavala. During rains, water overflows the steps, creating a natural waterfall effect, perfect for picnics and water fun. Families and tourists flock here to enjoy the scenic beauty, capture photographs, and savor local snacks from nearby vendors."
  },
  {
    "title": "Lonavala Lake",
    "description": "Lonavala Lake is a serene spot surrounded by hills and greenery, ideal for nature walks, photography, and peaceful reflection. The lake swells during monsoon, creating a picturesque landscape. It is less crowded, providing visitors a tranquil escape from the busy tourist spots."
  },
  {
    "title": "Rajmachi Point",
    "description": "Rajmachi Point offers breathtaking views of the Rajmachi Fort, Sahyadri mountains, and valleys. It is a popular trekking base for adventure seekers and history enthusiasts. The vantage point provides excellent opportunities for photography and enjoying panoramic vistas."
  },
  {
    "title": "Lion’s Point",
    "description": "Lion’s Point is a famous viewpoint overlooking the lush valleys and waterfalls of Lonavala. It is particularly popular during sunrise and sunset, offering stunning scenic beauty. Visitors enjoy trekking, photography, and the serene ambiance of the surrounding hills."
  },
  {
    "title": "Karla Caves",
    "description": "Karla Caves are ancient Buddhist rock-cut caves dating back to 2nd century BC, featuring intricate carvings, chaitya halls, and stone pillars. They are historically significant and attract tourists, history enthusiasts, and architecture lovers. The caves offer insights into India’s ancient Buddhist heritage."
  },
  {
    "title": "Della Adventure Park",
    "description": "Della Adventure Park is an adrenaline-packed destination in Lonavala, offering activities like bungee jumping, ATV rides, zip-lining, and more. Families, groups, and adventure seekers visit for thrilling experiences, team activities, and fun-filled excursions. The park is known for safety, hospitality, and a mix of adventure sports."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort is a historical hill fortress near Lonavala, popular for trekking and exploring Maratha architecture. The fort offers panoramic views of surrounding hills, valleys, and monsoon-fed landscapes. Visitors enjoy hiking, photography, and learning about the fort’s strategic importance during Shivaji Maharaj’s era."
  },
  {
    "title": "Kune Waterfalls",
    "description": "Kune Waterfalls is a three-tiered waterfall in Lonavala, surrounded by lush greenery and misty hills. It is ideal for photography, picnics, and nature walks. The waterfall is especially spectacular during monsoon, offering a refreshing and scenic experience for tourists and families."
  },
  {
    "title": "Ryewood Park",
    "description": "Ryewood Park is a peaceful garden in Lonavala with well-maintained lawns, walking paths, and picnic areas. It is perfect for family outings, morning walks, and relaxation amidst nature. The park’s greenery and serene environment provide a calm retreat from the bustling town."
  }
],






"services": [
{
"name": "Luxury Urbania on Rent in Lonavala",
"description": "Luxury Urbania on Rent in Lonavala offers fully air-conditioned, high-end Urbania buses for premium travel to the hill station. Ideal for families, corporate groups, and VIP travelers, the service ensures comfort, style, spacious seating, climate control, and professional chauffeur assistance for a smooth journey through scenic routes."
},
{
"name": "Lonavala Luxury Urbania Bus Hire",
"description": "Lonavala Luxury Urbania Bus Hire provides top-quality, air-conditioned Urbania buses for luxury travel to Lonavala. Perfect for corporate retreats, family vacations, and group tours, these buses feature plush interiors, ample luggage space, and professional chauffeurs to enhance the travel experience."
},
{
"name": "Premium Urbania Rental Lonavala",
"description": "Premium Urbania Rental Lonavala delivers high-end Urbania buses for comfortable and stylish trips. With well-maintained vehicles, trained drivers, and customer-focused service, it is ideal for hill station excursions, weekend getaways, and executive travel."
},
{
"name": "Urbania AC Luxury Bus Lonavala",
"description": "Urbania AC Luxury Bus Lonavala offers fully air-conditioned Urbania buses with spacious seating and modern amenities for a relaxing journey. Suitable for family tours, corporate trips, and VIP travel, ensuring comfort and punctuality throughout the ride."
},
{
"name": "Corporate Luxury Urbania Hire Lonavala",
"description": "Corporate Luxury Urbania Hire Lonavala provides professional transportation for business trips, executive retreats, and corporate events to the hill station. Features include air-conditioned buses, experienced chauffeurs, and reliable scheduling for seamless corporate travel."
},
{
"name": "Luxury Urbania for Outstation Lonavala",
"description": "Luxury Urbania for Outstation Lonavala offers well-maintained AC Urbania buses for safe, long-distance travel. Ideal for group tours, weekend getaways, and family trips, providing comfort, luggage support, and courteous drivers familiar with the route."
},
{
"name": "Chauffeur Driven Luxury Urbania Lonavala",
"description": "Chauffeur Driven Luxury Urbania Lonavala ensures a stress-free and premium travel experience with trained and verified drivers. Perfect for executives, VIPs, and families seeking reliable and comfortable transportation to Lonavala."
},
{
"name": "Wedding Luxury Urbania Lonavala",
"description": "Wedding Luxury Urbania Lonavala provides elegant, air-conditioned buses for wedding parties and guests traveling to and from Lonavala. Offers spacious interiors, comfort, and punctual service, making it ideal for special celebrations and family events."
},
{
"name": "Family Tour Luxury Urbania Lonavala",
"description": "Family Tour Luxury Urbania Lonavala delivers high-end, air-conditioned buses for memorable family trips to the hill station. Comfortable seating, climate control, and professional drivers make the journey safe and enjoyable for all age groups."
},
{
"name": "Best Luxury Urbania Rental Lonavala",
"description": "Best Luxury Urbania Rental Lonavala offers top-rated services with a fleet of air-conditioned Urbania buses for hill station travel. Known for reliability, vehicle quality, and customer satisfaction, perfect for corporate groups, families, and leisure travelers."
},
{
"name": "Executive Urbania Hire Lonavala",
"description": "Executive Urbania Hire Lonavala provides luxurious AC buses for corporate executives and VIPs traveling to Lonavala. Ensures comfort, punctuality, and professional chauffeur service for stress-free executive journeys."
},
{
"name": "Comfortable Luxury Urbania Lonavala",
"description": "Comfortable Luxury Urbania Lonavala ensures smooth and relaxing travel with spacious seating, modern interiors, and climate-controlled buses. Ideal for weekend trips, family outings, and group excursions to Lonavala."
},
{
"name": "High End Urbania Rental Lonavala",
"description": "High End Urbania Rental Lonavala delivers premium Urbania buses with advanced features for luxury travel. Perfect for corporate trips, family vacations, and VIP journeys, emphasizing safety, comfort, and style."
},
{
"name": "Trusted Luxury Urbania Service Lonavala",
"description": "Trusted Luxury Urbania Service Lonavala offers reliable and customer-focused transportation with fully AC buses and trained chauffeurs. Ensures timely arrivals, comfort, and safety for travelers visiting the hill station."
},
{
"name": "Luxury Hill Station Urbania Lonavala",
"description": "Luxury Hill Station Urbania Lonavala provides high-end, air-conditioned Urbania buses for scenic hill station trips. Ideal for families, corporate retreats, and VIPs, the service ensures comfortable travel with professional drivers and spacious interiors."
}
],
"tableData": [
["Luxury Urbania on Rent in Lonavala", "Lonavala Luxury Urbania Bus Hire"],
["Premium Urbania Rental Lonavala", "Urbania AC Luxury Bus Lonavala"],
["Corporate Luxury Urbania Hire Lonavala", "Luxury Urbania for Outstation Lonavala"],
["Chauffeur Driven Luxury Urbania Lonavala", "Wedding Luxury Urbania Lonavala"],
["Family Tour Luxury Urbania Lonavala", "Best Luxury Urbania Rental Lonavala"],
["Executive Urbania Hire Lonavala", "Comfortable Luxury Urbania Lonavala"],
["High End Urbania Rental Lonavala", "Trusted Luxury Urbania Service Lonavala"],
["Luxury Hill Station Urbania Lonavala", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Premium Luxury Urbania On Rent in Lonavala",
        "WhyChoosedescription": "Luxury Urbania On Rent in Lonavala is perfect for group trips, family outings, corporate travel, and leisure tours, offering a comfortable and spacious journey."
    },
    {
        "WhyChooseheading": "Spacious and Well-Equipped Force Urbania Vehicles",
        "WhyChoosedescription": "Luxury Urbania On Rent in Lonavala provides modern Force Urbania vehicles with air-conditioning, ample legroom, and comfortable seating for long and short trips."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Luxury Urbania On Rent in Lonavala comes with skilled drivers familiar with Lonavala, Pune, Mumbai, and nearby routes, ensuring safe, timely, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Luxury Urbania On Rent in Lonavala for competitive rates with no hidden charges, making group and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Luxury Urbania On Rent in Lonavala provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Luxury Urbania On Rent in Lonavala is available for hourly rentals, full-day bookings, multi-day trips, sightseeing tours, and customized travel plans."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles for Luxury Urbania On Rent in Lonavala are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Luxury Urbania On Rent in Lonavala guarantees on-time pickups and dependable service, ensuring smooth and stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Luxury Urbania On Rent in Lonavala available for local and outstation travel?',
        answer: 'Yes, Luxury Urbania On Rent in Lonavala can be booked for city travel, sightseeing, corporate trips, and long-distance journeys.',
    },
    {
        question: 'How can I book Luxury Urbania On Rent in Lonavala?',
        answer: 'You can book Luxury Urbania On Rent in Lonavala via phone, WhatsApp, or online for easy and quick reservations.',
    },
    {
        question: 'Why choose Luxury Urbania On Rent in Lonavala?',
        answer: 'Luxury Urbania On Rent in Lonavala offers spacious seating, professional drivers, clean vehicles, and transparent pricing for group, family, and corporate travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Luxury Urbania On Rent in Lonavala are licensed, trained, and experienced in handling Force Urbania vehicles safely.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Luxury Urbania On Rent in Lonavala allows flexible pickup and drop locations across Lonavala, Pune, Mumbai, and nearby areas.',
    },
    {
        question: 'Is Luxury Urbania On Rent in Lonavala available 24x7?',
        answer: 'Yes, Luxury Urbania On Rent in Lonavala operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all vehicles are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Luxury Urbania On Rent in Lonavala accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Luxury Urbania be used for sightseeing, family, and corporate trips?',
        answer: 'Yes, Luxury Urbania On Rent in Lonavala is ideal for sightseeing tours, family outings, corporate travel, and group trips.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Karan Mehta',
        feedback: 'Luxury Urbania On Rent in Lonavala provided a smooth and comfortable ride for our group trip. Spacious, clean, and professional service.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Joshi',
        feedback: 'We hired Luxury Urbania On Rent in Lonavala for a family trip. The vehicle was luxurious, punctual, and very comfortable.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Ritesh Sharma',
        feedback: 'Luxury Urbania On Rent in Lonavala made our weekend getaway hassle-free and enjoyable. Highly recommended.',
        rating: 5,
    },
];



























































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Urbania On Rent in Lonavala",
  "image": "https://urbaniaonrentpune.in/assets/images/luxury-urbania-lonavala.jpg",
  "description": "Luxury Urbania On Rent in Lonavala offers AC and non-AC Urbania buses for corporate trips, outstation travel, weddings, family tours, and hill station travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Lonavala and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/luxury-urbania-on-rent-lonavala"
  }
};








    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Luxury Urbania On Rent in Lonavala | AC & Premium Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Luxury Urbania On Rent in Lonavala for corporate trips, outstation travel, weddings, family tours, and hill station travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Lonavala."
  />

  <meta
    name="keywords"
    content="Luxury Urbania on Rent in Lonavala, Lonavala Luxury Urbania Bus Hire, Premium Urbania Rental Lonavala, Urbania AC Luxury Bus Lonavala, Corporate Luxury Urbania Hire Lonavala, Luxury Urbania for Outstation Lonavala, Chauffeur Driven Luxury Urbania Lonavala, Wedding Luxury Urbania Lonavala, Family Tour Luxury Urbania Lonavala, Best Luxury Urbania Rental Lonavala, Executive Urbania Hire Lonavala, Comfortable Luxury Urbania Lonavala, High End Urbania Rental Lonavala, Trusted Luxury Urbania Service Lonavala, Luxury Hill Station Urbania Lonavala"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/68.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Luxuryurbaniaonrentinlonavala;